import React from "react";
import useHover from "../../hooks/useHover";

const OpacityImg = ({ height, src, width, onClick }) => {
  const hover = useHover();
  return (
    <img
      onClick={() => {
        if (onClick) onClick();
      }}
      src={src}
      style={{
        cursor: "pointer",
        objectFit: "contain",
        height,
        width,
        opacity: hover.hover ? 1 : 0.5,
      }}
      {...hover.divProps}
    />
  );
};

export default OpacityImg;
